<div class="contract-list-container">
  <table mat-table [dataSource]="dataSource">

    <ng-container matColumnDef="partner">
      <th mat-header-cell *matHeaderCellDef> Partner</th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.partner">
          <a class="default-link" [routerLink]="['/partnerzy/szczegoly', element.partner?.uuid]">{{element.partner?.shortName}}</a>
        </ng-container>

      </td>
    </ng-container>

    <ng-container matColumnDef="contractWithEmployee">
      <th mat-header-cell *matHeaderCellDef> Umowa z pracownikiem </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="documentsDownloaded">
          {{ loadDocuments(element.uuid ) ? 'Tak' : 'Nie'}}
        </ng-container>
        <ng-container *ngIf="!documentsDownloaded" >
          <mat-progress-spinner   [diameter]="20"  mode="indeterminate"></mat-progress-spinner>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef> Rodzaj</th>
      <td mat-cell *matCellDef="let element">
        {{element.type.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="concludeDate">
      <th mat-header-cell *matHeaderCellDef> Data zawarcia</th>
      <td mat-cell *matCellDef="let element">
        {{element.concludeDate | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="company">
      <th mat-header-cell *matHeaderCellDef> Firma</th>
      <td mat-cell *matCellDef="let element">
        {{element.company.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status</th>
      <td mat-cell *matCellDef="let element">
        <button mat-raised-button [ngClass]="element.status.color + '-button'">{{element.status.name}}</button>
      </td>
    </ng-container>

    <ng-container matColumnDef="number">
      <th mat-header-cell *matHeaderCellDef> Numer</th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/umowy/szczegoly', element.uuid]">{{element.number}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="activeTo">
      <th mat-header-cell *matHeaderCellDef> Data zakończenia</th>
      <td mat-cell *matCellDef="let element">
        {{element.activeTo | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="activeFrom">
    <th mat-header-cell *matHeaderCellDef> Data podpisania umowy</th>
    <td mat-cell *matCellDef="let element">
      {{element.activeFrom | date:'y-MM-dd'}}
    </td>
  </ng-container>

    <ng-container matColumnDef="assetsRegional">
      <th mat-header-cell *matHeaderCellDef> Regionalny (majątek) </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.partner">
          {{element.partner.assetsRegional?.firstName}} {{element.partner.assetsRegional?.lastName}}
        </ng-container>

        <ng-container *ngIf="element.ofwca">
          {{element.ofwca.assetsRegional?.firstName}} {{element.ofwca.assetsRegional?.lastName}}
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button [matMenuTriggerFor]="menu"><mat-icon>expand_more</mat-icon></button>
        <mat-menu #menu="matMenu" xPosition="before">
          <button [disabled]="!(userPermissions | async).document.write" mat-menu-item (click)="addDocument(element)">Dodaj dokument</button>
<!--          <button [disabled]="!(userPermissions | async).contract.delete" mat-menu-item (click)="deleteContract(element)">Usuń</button>-->
        </mat-menu>
      </td>
    </ng-container>

    <ng-container matColumnDef="createdDate">
      <th mat-header-cell *matHeaderCellDef> Data utworzenia</th>
      <td mat-cell *matCellDef="let element">
        {{element.createdAt | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="released">
      <th mat-header-cell *matHeaderCellDef> Wydana </th>
      <td mat-cell *matCellDef="let element">
        <mat-slide-toggle
          *ngIf="documentsDownloaded"
          [disabled]="!(userPermissions | async).contract.delete || updateInProgress"
          [checked]="ofwca.released[element.uuid]===null ? false : ofwca.released[element.uuid] " (change)="formChanged(
            $event,
            element,
            {released: $event.checked, returned: ofwca.returned[element.uuid]===null ? false : ofwca.returned[element.uuid], contractUuid: element.uuid}
        )"></mat-slide-toggle>
      </td>
    </ng-container>

    <ng-container matColumnDef="releasedDate">
      <th mat-header-cell *matHeaderCellDef> Data wydania</th>
      <td mat-cell *matCellDef="let element">
        {{ofwca.releasedAt[element.uuid] | date:'y-MM-dd'}}
      </td>
    </ng-container>


    <ng-container matColumnDef="returned">
      <th mat-header-cell *matHeaderCellDef> Zwrócona </th>
      <td mat-cell *matCellDef="let element">
        <mat-slide-toggle
          *ngIf="documentsDownloaded"
          [disabled]="!(userPermissions | async).contract.delete || updateInProgress"
          [checked]="ofwca.returned[element.uuid]===null ? false : ofwca.returned[element.uuid]" (change)="formChanged(
            $event,
            element,
            { released: ofwca.released[element.uuid]===null ? false : ofwca.released[element.uuid]  , returned: $event.checked, contractUuid:  element.uuid}
        )"></mat-slide-toggle>
      </td>
    </ng-container>

    <ng-container matColumnDef="returnedDate">
      <th mat-header-cell *matHeaderCellDef> Data zwrócenia</th>
      <td mat-cell *matCellDef="let element">
        {{ofwca.returnedAt[element.uuid] | date:'y-MM-dd'}}
      </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50]"></mat-paginator>
</div>
